import src from "IMAGE";
export default { src, width: 1073, height: 1096, blurWidth: 0, blurHeight: 0};
